import domElementsFound from 'DOM/domElementsFound';

const selectors = {
  controlButton: '[data-quantity-change]',
  quantityComponent: '[data-quantity-controls]',
};

const state = {};

const handleQuantityChange = (change) => {
  const component = state.activeComponent;

  if (!component) return;

  const input = component.querySelector('input');
  const currentValue = parseInt(input.value, 10);
  const minValueAllowed = parseInt(input.getAttribute('min'), 10);

  const tempValue = currentValue + change;

  if (tempValue >= minValueAllowed) {
    input.value = tempValue;
  }
};

const handleQuantityControl = (event) => {
  const controlButton = event.target.closest(selectors.controlButton);

  if (!controlButton) return;

  const component = controlButton.closest(selectors.quantityComponent);
  state.activeComponent = component;
  const { quantityChange } = controlButton.dataset;
  handleQuantityChange(parseInt(quantityChange, 10));
};

const addEventListeners = () => {
  document.addEventListener('click', handleQuantityControl);
};

const quantityComponent = {
  init: () => {
    const quantityComponents = document.querySelectorAll(selectors.quantityComponent);

    if (!domElementsFound(quantityComponents)) return;

    addEventListeners();
  },
};

quantityComponent.init();
